export default {
  首页: "Startpagina",
  资产: "Activare",
  币币: "Spot",
  快捷买币: "Snel crypto kopen",
  "支持多种方式购买，购买更简单": "Koop eenvoudig met meerdere betaalmethoden",
  语言设置: "Taalinstellingen",
  确认恢复: "Herstel bevestigen",
  "输入邮箱，方便我们联系您":
    "Voer uw e-mailadres in zodat we contact met u kunnen opnemen",
  划转: "Overboeken",
  行情: "Markt",
  "24H成交": "24u Volume",
  累计收益: "Totale rente",
  充值时间: "Stortingsdatum",
  到期时间: "Vervaldatum",
  数量: "Hoeveelheid",
  操作: "Actie",
  资产信息: "Activagegevens",
  复制地址: "Adres kopiëren",
  链名称: "Blockchain naam",
  充值地址: "Stortingsadres",
  收款地址: "Ontvangstadres",
  账单: "Rekeningoverzicht",
  提现金额: "Opnamebedrag",
  接收地址: "Ontvangstadres",
  交易密码: "Handelspaswoord",
  提现全部: "Volledige opname",
  保存图片: "Afbeelding opslaan",
  输入您的交易密码: "Voer uw handelspaswoord in",
  确定: "Bevestigen",
  地址: "Adres",
  注册时间: "Registratiedatum",
  取消: "Annuleren",
  是否划转: "Overboeken?",
  登录: "Inloggen",
  我的地址: "Mijn adressen",
  登录密码和交易密码: "Inlog- en handelspaswoord",
  注册: "Registreren",
  密码: "Wachtwoord",
  设置密码: "Wachtwoord instellen",
  重复密码: "Herhaal wachtwoord",
  新密码: "Nieuw wachtwoord",
  确认新密码: "Bevestig nieuw wachtwoord",
  充值: "Storten",
  充值货币: "Valuta storten",
  合约账户充值: "Futures account storten",
  账户充值: "Account storten",
  其他: "Overig",
  我的邀请码: "Mijn uitnodigingscode",
  提现: "Opnemen",
  客服: "Klantenservice",
  持有详情: "Details bezit",
  请输入内容: "Voer inhoud in",
  邀请好友来领取奖励: "Nodig vrienden uit en ontvang beloningen",
  复制链接: "Link kopiëren",
  重复设置新的密码: "Herhaal nieuw wachtwoord",
  保存: "Opslaan",
  我的: "Mijn",
  "邮箱/手机号": "E-mailadres/Mobiel nummer",
  备注: "Opmerking",
  地址管理: "Adresbeheer",
  我的团队: "Mijn team",
  联系我们: "Contact",
  竭诚为您服务: "Wij staan voor u klaar",
  提取收益: "Rente opnemen",
  带给我的收益: "Rente gegenereerd",
  添加: "Toevoegen",
  名称: "Naam",
  添加地址: "Adres toevoegen",
  修改地址: "Adres wijzigen",
  可提现: "Opneembaar",
  安全中心: "Beveiligingscentrum",
  收益划转: "Rente overboeken",
  通知中心: "Meldingen",
  "累计收益:": "Totale rente:",
  注册用户: "Geregistreerde gebruikers",
  奖励规则: "Beloningsregels",
  帮助反馈: "Help & Feedback",
  邀请好友: "Vrienden uitnodigen",
  恢复身份: "Identiteit herstellen",
  选择语言: "Kies taal",
  设置新的密码: "Nieuw wachtwoord instellen",
  暂无活动: "Geen actieve acties",
  "月增长量(+)": "Maandelijkse groei (+)",
  可提取: "Opneembaar",
  反馈类型: "Feedbacktype",
  赠送: "Cadeau",
  已经复制: "Gekopieerd",
  保存成功: "Opslaan gelukt",
  划转成功: "Overboeking gelukt",
  过期: "Verlopen",
  提交成功: "Verzending gelukt",
  "服务器繁忙，稍后在试": "Server bezet, probeer later opnieuw",
  全部: "Alles",
  一级: "Niveau 1",
  二级: "Niveau 2",
  三级: "Niveau 3",
  级: "Niveau",
  删除成功: "Verwijderen gelukt",
  选择地址: "Selecteer adres",
  不再提醒: "Niet meer tonen",
  "最小充值金额：": "Minimale storting:",
  选择币种: "Kies cryptocurrency",
  输入投资金额: "Voer investeringsbedrag in",
  输入账户密码: "Voer accountwachtwoord in",
  投资: "Investeren",
  订单编号: "Ordernummer",
  投资周期: "Investeringsperiode",
  投资资金: "Geïnvesteerd bedrag",
  投资时间: "Investeringstijdstip",
  状态: "Status",
  投资中: "Actief",
  已到期: "Verlopen",
  暂无数据: "Geen gegevens",
  转入: "Overschrijving naar",
  邮箱: "E-mailadres",
  请输入邮箱: "Voer e-mailadres in",
  请输入格式正确的邮箱: "Voer een geldig e-mailadres in",
  请输入验证码: "Voer verificatiecode in",
  获取验证码: "Verificatiecode aanvragen",
  请输入邀请码: "Voer uitnodigingscode in",
  今天: "Vandaag",
  昨天: "Gisteren",
  最近七天: "Laatste 7 dagen",
  邀请: "Uitnodigen",
  购买数量: "Aantal kopen",
  产品详情: "Productdetails",
  币种: "Cryptocurrency",
  利息币种: "Rentecryptocurrency",
  理财类型: "Type financieel product",
  产品费率: "Productkosten",
  进行中: "Actief",
  每天: "Dagelijks",
  请输入搜索关键词: "Voer zoekterm in",
  通知: "Meldingen",
  查看更多: "Meer bekijken",
  理财宝: "Financiële producten",
  周期: "Looptijd",
  年利率: "Jaarlijks rentepercentage (APY)",
  更多产品: "Meer producten",
  灵活存取: "Flexibel sparen",
  稳定收益: "Stabiel rendement",
  合约指南: "Futures gids",
  资金划转出: "Uitgaande overboeking",
  矿池收益: "Mijnbouwbeloning",
  提现手续费: "Opnamekosten",
  冻结资金: "Geblokkeerd saldo",
  解冻资金: "Geblokkeerd saldo vrijgeven",
  闪兑支出: "Uitgave snelle omwisseling",
  闪兑收入: "Inkomsten snelle omwisseling",
  闪兑手续费: "Kosten snelle omwisseling",
  合约支出: "Uitgave futures",
  合约收入: "Inkomsten futures",
  输入的金额不可大于可用金额:
    "Bedrag mag niet groter zijn dan beschikbaar saldo",
  全部兑换成功: "Volledige omwisseling gelukt",
  返回: "Terug",
  查看历史: "Bekijk geschiedenis",
  闪兑历史: "Geschiedenis snelle omwisseling",
  支付: "Betalen",
  获取: "Ontvang",
  时间: "Tijd",
  手续费: "Transactiekosten",
  折扣: "Korting",
  价格: "Prijs",
  逐仓: "Isolated margin",
  全仓: "Cross margin",
  市价委托: "Market order",
  限价委托: "Limit order",
  请输入本金: "Voer hoofdsom in",
  请输入价格: "Voer prijs in",
  "可做空/做多": "Short/Long mogelijk",
  设置止盈止损: "Stel take-profit / stop-loss in",
  止盈价: "Take-profit prijs",
  止损价: "Stop-loss prijs",
  成本: "Kostprijs",
  做多: "Long",
  做空: "Short",
  仓位信息: "Positiegegevens",
  一键平仓: "Positie sluiten (een klik)",
  永续: "Perpetual",
  浮动盈亏: "Onwerkelijk resultaat",
  平仓: "Positie sluiten",
  反向开仓: "Omgekeerde positie openen",
  一键撤销: "Annuleer alles (een klik)",
  倍杠杆: "x hefboom",
  执行价格: "Uitvoeringsprijs",
  委托数量: "Orderhoeveelheid",
  保证金: "Marge",
  成交价: "Uitvoeringsprijs",
  创建时间: "Aanmaaktijd",
  撤销: "Annuleren",
  合约市场: "Futures markt",
  交易方向: "Transactierichting",
  委托价格: "Orderprijs",
  委托金额: "Orderbedrag",
  资金费率: "Financieringsrente",
  "多方和空方交易者支付的定期费用，每8小时结算一次。":
    "Periodieke vergoeding betaald door long- en shortposities, elke 8 uur verrekend.",
  "资金费率为正，多方向空方支付资金费用。":
    "Bij een positieve financieringsrente betalen longposities aan shortposities.",
  "资金费率为负，空方向多方支付资金费用。":
    "Bij een negatieve financieringsrente betalen shortposities aan longposities.",
  "确定反向开仓吗？反向开仓将以当期相反 的仓位进行买入":
    "Weet u zeker dat u een omgekeerde positie wilt openen? Dit koopt de tegenovergestelde richting van uw huidige positie.",
  "仓位止盈/止损": "Take-profit / Stop-loss voor positie",
  合约名称: "Futures contract",
  开仓价格: "Openingsprijs",
  指数价格: "Indexprijs",
  止盈设置: "Take-profit instellingen",
  请输入止盈价: "Voer take-profit prijs in",
  "当指数价格触达*时，将会触发委托平仓":
    "Wanneer de indexprijs * bereikt, wordt een sluitingsorder geactiveerd.",
  预计盈亏: "Verwachte winst/verlies",
  当前仓位: "Huidige positie",
  平仓金额: "Sluitingsbedrag",
  仓位模式: "Positiemodus",
  全仓模式: "Cross margin modus",
  "合约账户中的所有可用资金视作为可用保证金， 当仓位亏损超过了账户余额才会爆仓强平，并将损失所有 保证金和仓位，请注意":
    "In cross margin modus wordt alle beschikbare saldo in uw futures account als marge gebruikt. Liquidering vindt plaats wanneer het verlies uw totale saldo overschrijdt, waarmee u al uw marge en positie verliest.",
  逐仓模式: "Isolated margin modus",
  "会使合约账户中的一定数量保证金被分配到仓位上。如果保证金亏损低于维持保证金的水平，仓位被强平。在逐仓模式下，您可以为这个仓位增加和减少保证金。":
    "Een specifiek bedrag aan marge wordt toegewezen aan een positie. Als het margeverlies onder het onderhoudsmargeniveau zakt, wordt de positie geliquideerd. U kunt de marge voor deze positie verhogen of verlagen.",
  "是否撤销？": "Order annuleren?",
  "是否一键撤销？": "Alle orders annuleren?",
  "是否一键平仓？": "Alle posities sluiten?",
  持仓保证金: "Marge voor huidige positie",
  风险率: "Risicopercentage",
  未实现盈亏: "Onwerkelijk resultaat",
  可用保证金: "Beschikbare marge",
  净值: "Netto waarde",
  账户余额: "Saldo",
  合约计算器: "Futures calculator",
  交易记录: "Transactiegeschiedenis",
  "*倍杠杆": "*x hefboom",
  "平仓盈亏：": "Gesloten winst/verlies:",
  时间筛选: "Tijdfilter",
  仓位类型: "Positietype",
  订单状态: "Orderstatus",
  订单类型: "Ordertype",
  平仓价格: "Sluitingsprijs",
  持仓数量: "Positiehoeveelheid",
  "手续费(%)": "Transactiekosten (%)",
  平仓时间: "Sluitingstijd",
  平仓类型: "Sluitingstype",
  手动平仓: "Handmatig gesloten",
  强制平仓: "Gedwongen liquidatie",
  近1天: "Laatste dag",
  近7天: "Laatste 7 dagen",
  近30天: "Laatste 30 dagen",
  近180天: "Laatste 180 dagen",
  持仓: "Open positie",
  已取消: "Geannuleerd",
  分时: "Intraday",
  "24H额(USDT)": "24u Volume (USDT)",
  "24H低": "24u Laag",
  "24H量(BTC)": "24u Volume (BTC)",
  "24H高": "24u Hoog",
  "10秒": "10 seconden",
  "30秒": "30 seconden",
  "1分": "1 minuut",
  "3分": "3 minuten",
  "5分": "5 minuten",
  "30分": "30 minuten",
  "1小时": "1 uur",
  "4小时": "4 uur",
  "8小时": "8 uur",
  "1天": "1 dag",
  "1周": "1 week",
  "1月": "1 maand",
  单向持仓: "One-way positie",
  杠杆: "Hefboom",
  仓位: "Positie",
  计算结果: "Resultaat",
  盈亏: "Winst/Verlies",
  收益率: "Rendement",
  计算结果仅供参考: "Resultaat is indicatief",
  成交后仓位大小: "Positiegrootte na uitvoering",
  "计算结果仅供参考,实际结果可能因费率差异":
    "Resultaat is indicatief, werkelijke resultaten kunnen afwijken door transactiekosten.",
  目标价格: "Doelprijs",
  开始计算: "Berekenen",
  强平价格: "Liquidatieprijs",
  "充值前，请认真核对充值的链名称，充值错误无法找回资产*最小充值金额为*；少于此金额平台将无法确认到账，请不要向此地址充值*之外的资产，否则将无法找回资产，请不要直接提现众筹或者ICO地址，平台不会代理币的发放。":
    "Controleer voor het storten zorgvuldig de blockchainnaam. Verkeerde stortingen kunnen niet worden teruggedraaid. Het minimum stortingsbedrag is *. Stortingen onder dit bedrag worden niet verwerkt. Stuur geen andere activa naar dit adres. Gebruik geen ICO- of crowdfunding-adressen voor opnames.",
  "最小输入*": "Minimaal {0}",
  "最小提币数量为*，提币手续费将从你的提款金额中扣除。提币前请确认核对收款地址，不要将*提现至*以外的地址，否则无法找回资产。请不要直接提现众筹或者ICO地址，平台不会处理代币的发放。":
    "De minimale opnamehoeveelheid is *. Opnamekosten worden van het opnamebedrag afgetrokken. Controleer het ontvangstadres zorgvuldig. Stuur geen * naar adressen buiten *. Gebruik geen ICO- of crowdfunding-adressen.",
  退出登录: "Uitloggen",
  加仓: "Positie uitbreiden",
  新增仓位: "Nieuwe positie",
  输入加仓金额: "Voer bedrag voor positie-uitbreiding in",
  "当前可用:": "Huidig beschikbaar:",
  资产账单: "Activarekeningoverzicht",
  保存二维码: "QR-code opslaan",
  温馨提示: "Let op",
  "请注意：您当前使用的网络": "Let op: U gebruikt momenteel het netwerk",
  输入提现地址: "Voer opnameadres in",
  "可用金额：": "Beschikbaar bedrag:",
  输入资产密码: "Voer activawachtwoord in",
  可用手续费: "Beschikbare transactiekosten",
  "折扣%": "Korting %",
  实扣手续费: "Werkelijk in rekening gebrachte kosten",
  实际到账: "Werkelijk ontvangen bedrag",
  未设置资产密码: "Geen activawachtwoord ingesteld",
  "为了您的资产安全，请设置资产密码后再来提现。":
    "Stel voor uw veiligheid een activawachtwoord in voordat u opnames doet.",
  热榜: "Populair",
  涨幅榜: "Stijgers",
  跌幅榜: "Dalers",
  成交额榜: "Volume ranglijst",
  关于我们: "Over ons",
  登录密码: "Inlogwachtwoord",
  设置: "Instellingen",
  资产密码: "Activawachtwoord",
  修改登录密码: "Inlogwachtwoord wijzigen",
  原密码: "Oud wachtwoord",
  请输入新密码: "Voer nieuw wachtwoord in",
  请输入原密码: "Voer oud wachtwoord in",
  确认密码: "Bevestig wachtwoord",
  确定修改: "Wijzigen bevestigen",
  修改资产密码: "Activawachtwoord wijzigen",
  验证码: "Verificatiecode",
  资产密码使用提示: "Activawachtwoord tips",
  "资产密码用于转移、提取资产和交易。":
    "Activawachtwoord wordt gebruikt voor het overboeken, opnemen en verhandelen van activa.",
  "创建与登录密码不同的资产密码。":
    "Kies een ander wachtwoord dan uw inlogwachtwoord.",
  "定期更改您的资产密码。": "Wijzig uw activawachtwoord regelmatig.",
  提币历史: "Opnamegeschiedenis",
  "金额/余额": "Bedrag/Saldo",
  "手续费/折扣": "Kosten/Korting",
  自选: "Favorieten",
  现货: "Spot",
  市价: "Marktprijs",
  止损设置: "Stop-loss instellingen",
  合约K线图: "Futures kaart",
  "24H量": "24u Volume",
  "24H额": "24u Volume (USDT)",
  合作指南: "Partner gids",
  盈亏计算: "Winst/Verlies berekening",
  当前可用: "Huidig beschikbaar",
  请输入加仓金额: "Voer bedrag voor positie-uitbreiding in",
  请重新输入加仓金额: "Voer het bedrag voor positie-uitbreiding opnieuw in",
  平仓数量: "Te sluiten hoeveelheid",
  欢迎登录: "Welkom terug",
  "忘记密码?": "Wachtwoord vergeten?",
  "还没有账号？": "Nog geen account?",
  立即注册: "Nu registreren",
  繁體中文: "Traditioneel Chinees",
  找回密码: "Wachtwoord herstellen",
  下一步: "Volgende",
  注册账户: "Account registreren",
  "请输入邀请码(选填)": "Voer uitnodigingscode in (optioneel)",
  谢邀豪礼: "Uitnodigingsbonus",
  "24小时邀请好友排名": "24u uitnodigingsranglijst",
  "*人": "* personen",
  "差*人": "Nog * personen nodig",
  "已超过10万人，每月轻松赚钱":
    "Meer dan 100.000 gebruikers, verdien eenvoudig elke maand",
  最高: "Maximaal",
  邀请链接: "Uitnodigingslink",
  "平台和您共享好友在平台（现货、合约、杠杆、闪兑）所产生的手续费":
    "Deel in de transactiekosten gegenereerd door uw vrienden (spot, futures, margin, snelle omwisseling).",
  平台和您一起分享手续费: "Deel in de transactiekosten met het platform",
  "*级": "* niveau",
  规则: "Regels",
  我的好友: "Mijn vrienden",
  好友详情: "Vrienddetails",
  获得好友佣金方案: "Vriendencommissieplan",
  我的等级: "Mijn niveau",
  我的邀请数据: "Mijn uitnodigingsstatistieken",
  当前等级: "Huidig niveau",
  平台奖励您: "Platformbeloning voor u",
  最高可获取平台奖励: "Maximale platformbeloning",
  邀请规则: "Uitnodigingsregels",
  "邀请*级有效好友": "Nodig * niveau actieve vrienden uit",
  好友等级: "Vriendniveau",
  人: "personen",
  奖金派送: "Bonusuitkering",
  平台奖励: "Platformbeloning",
  "最终解释权归平台所有，若发现异常获取平台奖励，将会扣除所有的奖励，并且冻结账户，资产的损失将无法找回。":
    "Het platform heeft het recht op uitleg. Bij frauduleuze activiteiten worden beloningen ingehouden en wordt uw account bevroren. Verloren activa kunnen niet worden teruggevonden.",
  "您的账户必须是有效账户，平台判定有效账户条件为（账户充值任何币种）最小* USDT的价值。":
    "Uw account moet actief zijn, gedefinieerd als een storting van ten minste * USDT aan waarde in welke cryptocurrency dan ook.",
  "您邀请的好友，必须是有效下级，平台判定有效下级为（账户充值任何币种）最小* USDT的价值。":
    "Uw uitgenodigde vriend moet een actieve downline zijn, gedefinieerd als een storting van ten minste * USDT aan waarde.",
  "邀请人和被邀请者的账号不能同属于一个IP。":
    "Uitnodiger en genodigde mogen niet hetzelfde IP-adres delen.",
  "VIP等级由您邀请的*级好友的人数作为考核。":
    "VIP-niveau wordt bepaald door het aantal uitgenodigde vrienden van * niveau.",
  佣金成分: "Commissiecomponenten",
  收益统计: "Rente Statistieken",
  昨日收益: "Rente van gisteren",
  月收益: "Maandrente",
  获取收益: "Rente ontvangen",
  "总收益：": "Totale rente:",
  "*级好友": "* niveau vrienden",
  理财购买: "Financieel product kopen",
  期限: "Looptijd",
  可用金额: "Beschikbaar bedrag",
  预估收益: "Geschat rendement",
  申购上限: "Maximale aankoop",
  项目剩余: "Resterend projectaanbod",
  "买入后预计*(SGT)开始计算收益。":
    "Rente begint naar verwachting op *(SGT) na aankoop.",
  计息日: "Rente startdatum",
  申购日: "Aankoopdatum",
  到账日: "Betaaldatum",
  到期自动续投: "Automatisch herinvesteren bij vervaldatum",
  申购: "Aankopen",
  搜索理财项目: "Zoek financieel product",
  超高年化随心选: "Kies uit producten met hoge rente",
  "自由选择理财币种，稳定超额收益":
    "Kies vrij uw cryptocurrency voor stabiele, bovenmatige rendementen",
  理财总资产: "Totaal belegd vermogen",
  申购数量: "Aantal aan te kopen",
  立即购买: "Direct kopen",
  年化收益率: "Jaarlijks rentepercentage (APY)",
  理财订单: "Financieel product orders",
  持有: "In bezit",
  申购份额: "Aangekocht deel",
  到账日期: "Betaaldatum",
  申购成功: "Aankoop gelukt",
  到期: "Verlopen",
  是否选择做多: "Long gaan?",
  "可用余额为0 不能操作": "Saldo is 0, actie niet mogelijk",
  福利中心: "Bonuscentrum",
  奖励记录: "Beloningsgeschiedenis",
  我获取到的奖励: "Mijn verdiende beloningen",
  总价值: "Totale waarde",
  新手任务: "Nieuwkomertaken",
  身份认证: "Identiteitsverificatie (KYC)",
  身份验证: "Identiteitsverificatie",
  去验证: "Verifieer nu",
  审核中: "In afwachting",
  已验证: "Geverifieerd",
  认证失败: "Verificatie mislukt",
  基础认证: "Basisverificatie",
  "请注意认证信息一经验证不能修改，务必填写准确信息":
    "Let op: geverifieerde informatie kan niet meer worden gewijzigd. Vul accurate gegevens in.",
  "国家/地区": "Land/Regio",
  请选择: "Selecteer",
  证件类型: "Documenttype",
  证件编码: "Documentnummer",
  身份证: "Identiteitskaart",
  护照: "Paspoort",
  驾驶证: "Rijbewijs",
  请输入编码: "Voer nummer in",
  名字: "Voornaam",
  请输入: "Voer in",
  中间名: "Tweede naam",
  选填: "Optioneel",
  姓氏: "Achternaam",
  中国: "China",
  身份上传: "Upload identiteitsbewijs",
  上传身份证: "Upload identiteitskaart",
  "以上材料需要用JPG/JPEG/PNG格式上传，并且保证照片的清晰边角完整，亮度均匀。且大小不超过*M。":
    "Upload in JPG/JPEG/PNG-formaat. Zorg voor duidelijke, volledige afbeeldingen met gelijkmatige belichting. Maximaal *MB.",
  确定提交: "Verzenden",
  去认证: "Verifiëren",
  挑战任务: "Uitdagingstaken",
  注册认证任务: "Registratie- en verificatietaak",
  完成注册认证即可领取: "Voltooi registratie en verificatie om te claimen",
  领取奖励: "Claim beloning",
  新人豪礼: "Welkomstbonus",
  "参与人数：": "Aantal deelnemers:",
  条件: "Voorwaarde",
  入金量: "Stortingsbedrag",
  完成: "Voltooid",
  任务奖励: "Taakbeloning",
  距任务更新: "Tot taakupdate",
  "条件：": "Voorwaarde:",
  活动规则: "Actieregels",
  奖励明细: "Beloningsdetails",
  已获得: "Verworven",
  交易奖励: "Handelsbeloning",
  Win奖励: "WIN beloning",
  已领取: "Geclaimd",
  亏损金额超过: "Verliesbedrag overschrijdt",
  单笔开仓金额超过: "Enkel orderbedrag overschrijdt",
  交易量: "Handelsvolume",
  待完成: "Te voltooien",
  入金: "Storten",
  盈利金额超过: "Winstbedrag overschrijdt",
  开仓金额: "Orderbedrag",
  开仓金: "Orderbedrag",
  盈利: "Winst",
  亏损: "Verlies",
  领取: "Claimen",
  未领取: "Niet geclaimd",
  待领取: "Te claimen",
  再交易: "Handel verder",
  即可获得: "om te ontvangen",
  领取成功: "Claimen gelukt",
  "1、所有的活动都会按照活动最后的时间进行统计收益过期后将无效。":
    "1. Alle activiteiten worden verrekend op de einddatum. Beloningen verlopen daarna.",
  "2、获得的收益会发放到您的赏金账户中，你可以随时根据您的需要进行兑换和提现。":
    "2. Verdiende rente wordt bijgeschreven op uw Bounty-rekening, die u kunt omwisselen of opnemen.",
  "3、获取的到的奖励币种类型根据任务按类型发放。":
    "3. Beloningscryptocurrency is afhankelijk van de taak.",
  "4、最终解释权归平台所有，若发现存在异常手段套利平台的任务奖金，平台有权冻结并且清除您获取的收益。":
    "4. Het platform heeft het recht op uitleg. Bij fraude met taken worden beloningen ingehouden en kan uw account worden bevroren.",
  成长学院: "Academie",
  "区块链 & 加密货币": "Blockchain & Cryptocurrency",
  "您的加密货币一站式指南，我们带您开启加密货币之路。":
    "Uw complete gids voor cryptocurrency. Wij leiden u op uw cryptoreis.",
  "全仓合约定单的全部保证金。":
    "Totale marge voor cross margin futures orders.",
  "(账户余额+(浮动盈亏-手续费-过夜费)=净值/已用保证金*100":
    "(Saldo + (onwerkelijk resultaat - kosten - financieringsrente) = Netto waarde / Gebruikte marge * 100",
  "浮动盈亏会直接影响”可用保证金“，当未实现盈亏增加，可用保证金将会增加，未实现盈亏减少，可用保证金同样也会减少。":
    "Onwerkelijk resultaat heeft directe invloed op de 'beschikbare marge'. Als het onwerkelijk resultaat toeneemt, neemt de beschikbare marge toe en vice versa.",
  "账户余额-(已用保证金)+(浮动盈亏-手续费-过夜费)":
    "Saldo - (Gebruikte marge) + (onwerkelijk resultaat - kosten - financieringsrente)",
  "注:可继续用于开仓的保证金。":
    "Opmerking: Marge die beschikbaar is om nieuwe posities te openen.",
  "账户余额+(浮动盈亏-手续费-过夜费)":
    "Saldo + (onwerkelijk resultaat - kosten - financieringsrente)",
  "注:当前的资金结余。": "Opmerking: Huidige saldo.",
  "指的是合约账户的全部余额，包含不可用余额。":
    "Verwijst naar het totale saldo van de futures-rekening, inclusief geblokkeerd saldo.",
  "注:风险率越高，风险越低，风险率越低，风险越高。":
    "Opmerking: Hoe hoger het risicopercentage, hoe lager het risico en vice versa.",
  该功能尚未开发: "Deze functie is nog in ontwikkeling",
  重置密码: "Wachtwoord resetten",
  "请输入为8-20位，必须包含字母、数字和特殊字符":
    "Voer 8-20 tekens in, inclusief letters, cijfers en speciale tekens",
  修改成功: "Wijzigen gelukt",
  输入验证码: "Voer verificatiecode in",
  输入密码: "Voer wachtwoord in",
  详情说明: "Details",
  已售罄: "Uitverkocht",
  剩余期限: "Resterende looptijd",
  限期: "Looptijd",
  闪兑货币选择: "Selecteer valuta voor snelle omwisseling",
  地区选择: "Regio selecteren",
  "搜索国家/地区": "Zoek land/regio",
  "身份信息已提交，将在*小时内审核完成":
    "Identiteitsgegevens verzonden. Verwerking duurt tot * uur.",
  "选择国家/地区": "Selecteer land/regio",
  "止盈价格需高于*": "Take-profit prijs moet hoger zijn dan *",
  "止损价格需低于*": "Stop-loss prijs moet lager zijn dan *",
  "止盈价格需低于*": "Take-profit prijs moet lager zijn dan *",
  "止损价格需高于*": "Stop-loss prijs moet hoger zijn dan *",
  教程详情: "Tutorial details",
  请输入止损价: "Voer stop-loss prijs in",
  活期: "Flexibel",
  赎回后立即到账: "Onmiddellijke uitbetaling na terugkoop",
  赎回: "Terugkopen",
  赎回理财: "Financieel product terugkopen",
  是否赎回当前的理财订单: "Huidige financiële order terugkopen?",
  维护: "Onderhoud",
  "系统正在维护中……": "Systeem in onderhoud...",
  合约: "Futures",
  闪电兑换: "Snelle omwisseling",
  流水挖矿: "Volume mining",
  邀请豪礼: "Uitnodigingsbonus",
  计算器: "Rekenmachine",
  最新价: "Laatste prijs",
  涨跌幅: "Verandering (24u)",
  关注币种添加自选: "Voeg cryptocurrency toe aan favorieten",
  一键添加自选: "Toevoegen aan favorieten (een klik)",
  全标已读: "Markeer alles als gelezen",
  无消息: "Geen berichten",
  "暂时还没有收到任何消息通知哦!": "Nog geen meldingen ontvangen!",
  没有更多数据: "Geen verdere gegevens",
  闪兑: "Snelle omwisseling",
  从: "Van",
  "可用余额：": "Beschikbaar saldo:",
  至: "Naar",
  预览兑换结果: "Bekijk omwisselresultaat",
  闪兑规则: "Regels voor snelle omwisseling",
  "市场闪兑可能变动，请以实际到账的金额数量为准。":
    "Snelle omwisseling is onderhevig aan marktschommelingen. Het uiteindelijk ontvangen bedrag is leidend.",
  "对汇兑率由第三方制定，由于兑换成本以及市场波动，您兑换的汇率可能会高于市场的汇率，请仔细确认后进行操作。":
    "Wisselkoersen worden bepaald door derden. Door kosten en schommelingen kan de koers afwijken van de marktkoers. Controleer zorgvuldig.",
  "平台对每笔汇兑收取大约*%的手续费，用于支付在交易所兑换成本。":
    "Het platform rekent ongeveer *% kosten per omwisseling om wisselkosten op exchanges te dekken.",
  确认汇兑: "Bevestig omwisseling",
  您预估得到: "Geschatte ontvangst",
  汇兑: "Omwisseling",
  汇兑比例: "Wisselkoers",
  刷新: "Vernieuwen",
  兑换: "Omwisselen",
  没有更多了: "Geen verdere gegevens",
  搜索币种: "Zoek cryptocurrency",
  可用: "Beschikbaar",
  我知道了: "Ik begrijp het",
  最新价格: "Laatste prijs",
  确认: "Bevestigen",
  最大: "Maximaal",
  "风险率(%)": "Risicopercentage (%)",
  当前委托: "Huidige orders",
  合作交易历史记录: "Partner transactiegeschiedenis",
  重置: "Reset",
  余额: "Saldo",
  现货账户: "Spot account",
  合约账户: "Futures account",
  WIN账户: "WIN account",
  赏金账户: "Bounty account",
  总资产折合: "Totaal vermogen (in USDT)",
  今日收益: "Rente vandaag",
  充币: "Storten",
  提币: "Opnemen",
  账户权益: "Rekeningwaarde",
  "数量/类别": "Hoeveelheid/Categorie",
  全部币种: "Alle cryptocurrencies",
  全部类型: "Alle typen",
  账单信息: "Rekeningoverzicht info",
  理财赎回: "Financieel product terugkoop",
  购买理财: "Financieel product kopen",
  收入: "Inkomsten",
  支出: "Uitgaven",
  到: "naar",
  资产划转: "Activa overboeking",
  "最少*": "Minimaal *",
  "可用资产：": "Beschikbare activa:",
  确认划转: "Bevestig overboeking",
  "只有将资产划转至对于的账户才可以进行交易，账户间的划转不收取手续费。":
    "U moet activa naar de juiste account overboeken om te kunnen handelen. Overboekingen tussen accounts zijn kosteloos.",
  币种账户选择: "Selecteer cryptocurrency account",
  选择账户: "Selecteer account",
  划转详情: "Overboekingsdetails",
  划转明细: "Overboekingsspecificaties",
  收入账单: "Inkomstenoverzicht",
  支出账单: "Uitgavenoverzicht",
  金额: "Bedrag",
  总收益: "Totale rente",
  佣金: "Commissie",
  用户名: "Gebruikersnaam",
  "已领取：": "Geclaimd:",
  "未领取：": "Niet geclaimd:",
  "请选择国家/地区": "Selecteer land/regio",
  请上传身份信息: "Upload identiteitsgegevens",
  请选择证件类型: "Selecteer documenttype",
  请填写证件编码: "Vul documentnummer in",
  请填写名字: "Vul voornaam in",
  请填写姓氏: "Vul achternaam in",
  投资金额: "Investeringsbedrag",
  天: "dagen",
  请输入手机号: "Voer mobiel nummer in",
  搜索: "Zoeken",
  搜索历史: "Zoekgeschiedenis",
  热门推荐: "Populaire aanbevelingen",
  "《Xspace Earn协议》": "Xspace Earn Protocol",
  我已了解并同意: "Ik begrijp en ga akkoord met de",
  协议: "Protocol",
  Xspace官方中文交流群: "Xspace officiële Chinese community",
  Xspace官方英文交流群: "Xspace officiële Engelse community",
  预计维护至: "Verwacht onderhoud tot",
  更多功能: "Meer functies",
  下载APP: "Download App",
  理财: "Financieel product",
  推荐: "Aanbevolen",
  Telegram官方中文频道: "Officieel Telegram-kanaal (Chinees)",
  Telegram官方英文频道: "Officieel Telegram-kanaal (Engels)",
  官方邮箱: "Officieel e-mailadres",
  客服邮箱: "Klantenservice e-mailadres",
  上述信息最终解释权归官方所有:
    "Bovenstaande informatie is onderhevig aan de officiële uitleg van het platform.",
  IOS版下载: "Download voor iOS",
  Android版下载: "Download voor Android",
  "手续费=买入手续费+资金费率+卖出手续费":
    "Transactiekosten = Aankoopkosten + Financieringsrente + Verkoopkosten",
  资金划转: "Activa overboeking",
  止盈: "Take-profit",
  止损: "Stop-loss",
  自动平仓: "Automatisch sluiten",
  委托挂单: "Open order",
  买: "Koop",
  卖: "Verkoop",
  "买入/做多": "Kopen/Long",
  "卖出/做空": "Verkopen/Short",
  详情: "Details",
  浮动涨跌: "Onwerkelijk resultaat",
  最小: "Minimum",
  充币数量: "Te storten hoeveelheid",
  请输入充币数量: "Voer stortingshoeveelheid in",
  支付截图: "Betalingsbewijs",
  提交: "Verzenden",
  上传驾驶证: "Upload rijbewijs",
  上传护照: "Upload paspoort",
  加载中: "Laden...",
  上传成功: "Upload gelukt",
  充值历史: "Stortingsgeschiedenis",
  合约卖出手续费: "Futures verkoopkosten",
  合约买入手续费: "Futures aankoopkosten",
  系统加款: "Systeem credit",
  系统减款: "Systeem debet",
  合约资金费率: "Futures financieringsrente",
  佣金分成: "Commissieverdeling",
  U本位合约: "USDT-margined futures",
  资产管理: "Activabeheer",
  APP下载: "App downloaden",
  全球领先的数字理财平台:
    "'S werelds toonaangevende digitaal financieel platform",
  "即刻交易比特币、以太坊等上百种数字资产":
    "Handel direct in Bitcoin, Ethereum en honderden andere digitale activa",
  "24H涨跌幅": "24u verandering",
  查看更多行情: "Bekijk meer markten",
  近24小时成交量: "24u volume",
  "提供数百种币币和合约交易对，以满足多样化的交易需求。 平台在200个国家和地区中有超过2千万用户，是全球领先的数字资产服务平台。":
    "Biedt honderden spot- en futures-paren. Meer dan 20 miljoen gebruikers in 200+ landen. Een wereldwijd toonaangevend digitaal activa platform.",
  用户国家分布: "Gebruikers per land",
  用户数: "Aantal gebruikers",
  交易对: "Handelsparen",
  服务支持: "Ondersteuning",
  "随时随地，多平台终端交易": "Handel overal met multi-platform ondersteuning",
  "多终端完美兼容，随时满足各种场景的交易需求。":
    "Perfect compatibel met meerdere apparaten voor alle handelsbehoeften.",
  随时查看实时行情: "Bekijk realtime koersen altijd en overal",
  "轻松买卖BTC，ETH，DOGE和其他数字资产":
    "Koop en verkoop eenvoudig BTC, ETH, DOGE en andere digitale activa",
  获取您关注的加密货币价格变化预警:
    "Ontvang prijswaarschuwingen voor cryptocurrencies die u volgt",
  "查看比特币现货、期货、期权价格":
    "Bekijk Bitcoin spot-, futures- en optieprijzen",
  比较各交易所加密货币价格: "Vergelijk cryptocurrency prijzen over exchanges",
  开启您的数字货币之旅: "Begin uw digitale activa reis",
  快捷购买数字货币: "Koop snel cryptocurrencies",
  "使用多种支付方式交易数字货币，安全快捷":
    "Handel veilig en snel met meerdere betaalmethoden",
  最优的交易费率: "De beste transactiekosten",
  "优惠的交易费率，富有竞争力的VIP权益，享受最优品质的服务":
    "Voordelige tarieven, competitieve VIP-voordelen en service van topkwaliteit.",
  可信赖的安全保障: "Betrouwbare veiligheid",
  "我们复杂的安全措施和SAFU基金保护您的数字资产免受所有风险。":
    "Geavanceerde beveiliging en het SAFU-fonds beschermen uw activa tegen risico's.",
  交易: "Handel",
  币币市场: "Spotmarkt",
  "24H成交量": "24u Volume",
  交易所: "Beurs",
  "24H最高": "24u Hoog",
  "24H最低": "24u Laag",
  永续合约: "Perpetual futures",
  日涨跌: "Dagelijkse verandering",
  交易深度: "Orderboekdiepte",
  "资产(合约)": "Activa (Futures)",
  历史仓位: "Positiegeschiedenis",
  兑换记录: "Omwisselgeschiedenis",
  类型: "Type",
  充值记录: "Stortingsgeschiedenis",
  划转记录: "Overboekingsgeschiedenis",
  类别: "Categorie",
  历史账单: "Rekeningoverzicht geschiedenis",
  在线充值: "Online storten",
  安全设置: "Beveiligingsinstellingen",
  用于账户登录使用: "Wordt gebruikt voor accountlogin",
  用户提现时安全验证使用:
    "Wordt gebruikt voor veiligheidsverificatie bij opnames",
  验证: "Verifiëren",
  万: "miljoen",
  随时随地开启交易: "Start handelen altijd en overal",
  "*货币交易所的所有功能尽在你的手中。":
    "Alle functies van de * crypto exchange in uw hand.",
  "下载*货币交易所APP。": "Download de * crypto exchange app.",
  下载自: "Download van",
  内测版: "Beta-versie",
  下载: "Downloaden",
  扫码下载: "Scan om te downloaden",
  设置您的资产密码: "Stel uw activawachtwoord in",
  法币: "Fiat",
  我要买: "Ik wil kopen",
  我要卖: "Ik wil verkopen",
  请输入金额: "Voer bedrag in",
  汇率: "Wisselkoers",
  获得: "Ontvang",
  支付通道: "Betalingskanaal",
  收款通道: "Ontvangstkanaal",
  "出售过程需要务必确认好您的收款方式为本人。":
    "Zorg ervoor dat het ontvangstkanaal op uw eigen naam staat tijdens de verkoop.",
  当前法币暂不支持交易对可尝试前往提现:
    "Dit fiat paar wordt momenteel niet ondersteund. Probeer een opname.",
  前往提现: "Ga naar opnemen",
  该法币暂无通道: "Geen beschikbaar kanaal voor deze fiat",
  "正在出售中，请耐心等待": "Verkoop bezig, even geduld a.u.b.",
  请选择支付通道: "Selecteer betalingskanaal",
  请选择方式: "Selecteer methode",
  法币历史: "Fiat geschiedenis",
  买币: "Crypto kopen",
  卖币: "Crypto verkopen",
  失败: "Mislukt",
  已完成: "Voltooid",
  未付款: "Onbetaald",
  待审核: "In afwachting",
  打款中: "Uitbetaling bezig",
  订单详情: "Orderdetails",
  联系客服: "Neem contact op met klantenservice",
  到账金额: "Ontvangen bedrag",
  通道: "Kanaal",
  收款人: "Ontvanger",
  收款账户: "Ontvangerrekening",
  "订单出售失败，请查下方失败原因":
    "Verkooporder mislukt. Zie hieronder voor de reden.",
  失败原因: "Reden voor mislukking",
  您还未进行付款: "U heeft nog niet betaald",
  您已成功购买: "Aankoop gelukt",
  已取消订单: "Order geannuleerd",
  "订单正在审核中，请耐心等待": "Order in behandeling. Even geduld a.u.b.",
  您已成功出售: "Verkoop gelukt",
  "订单正在打款中，请耐心等待": "Uitbetaling bezig. Even geduld a.u.b.",
  "支付过程需要您前往其他的平台进行支付订单，请注意信息安全。":
    "Voor betaling moet u een ander platform bezoeken. Let op uw informatiebeveiliging.",
  当前法币暂不支持交易对可尝试前往充值:
    "Dit fiat paar wordt momenteel niet ondersteund. Probeer een storting.",
  前往充值: "Ga naar storten",
  购买: "Kopen",
  订单号: "Ordernummer",
  单价: "Eenheidsprijs",
  到账数量: "Ontvangen hoeveelheid",
  "当前存在未付的订单，是否继续发起新的支付订单？":
    "Er is een onbetaalde order. Nieuwe betalingsorder starten?",
  继续支付: "Doorgaan met betalen",
  重新下单: "Nieuwe bestelling plaatsen",
  是否确定出售: "Weet u zeker dat u wilt verkopen?",
  "确定出售后，平台将分配给买家，请耐心等待平台的撮合。":
    "Na bevestiging wijst het platform een koper toe. Wacht op de matchmaking.",
  出售: "Verkopen",
  收款方式: "Ontvangstmethode",
  订单已生成: "Order gegenereerd",
  取消订单: "Order annuleren",
  请在: "Gelieve binnen",
  内完成付款: "te betalen",
  "离开平台，登录您指定的支付，转账到卖家的以下账户，并务必在付款中备注：":
    "Verlaat het platform, log in op uw gekozen betaalmethode en doe de betaling naar de onderstaande rekening van de verkoper. Vermeld altijd de referentie:",
  "若付款时未进行备注，卖家将无法确认收款，造成资产损失无法找回。":
    "Zonder referentie kan de verkoper de betaling niet bevestigen, wat kan leiden tot verlies van activa.",
  "未在规定的时间内付款，订单都将被取消。":
    "Als u niet binnen de gestelde tijd betaalt, wordt de order geannuleerd.",
  姓名: "Naam",
  收款姓名: "Naam ontvanger",
  开户支行: "Bankfiliaal",
  银行卡号: "Bankkaartnummer",
  "付款后，返回本平台": "Keer na betaling terug naar dit platform",
  "请务必点击下方“我已完成付款，通知卖家”按钮":
    "Klik op de knop 'Ik heb betaald, meld verkoper'",
  未点击卖家不会放款:
    "De verkoper geeft de crypto pas vrij nadat u op de knop heeft geklikt",
  交易条款: "Transactievoorwaarden",
  "购买资金来源，必须合法安全的资金，方可交易":
    "De middelen voor aankoop moeten legaal en veilig zijn",
  "不允许诈骗、传销、赌博或者其他非法资金交易":
    "Fraude, piramidespel, gokken of andere illegale middelen zijn niet toegestaan",
  "交易完成后，出现资金风险，被冻结或者涉嫌欺诈、传销、赌博的资金，我方将不在向买方放U，并给予退款":
    "Als na de transactie het geld wordt bevroren of verdacht wordt van fraude, geven wij de USDT niet vrij en geven wij een terugbetaling",
  "已付款，通知卖家": "Betaald, meld verkoper",
  "买方当日累计取消*笔订单，将会取消当日购买功能。确定取消该订单吗？":
    "Als u vandaag in totaal * orders annuleert, wordt uw kooprecht voor vandaag ingetrokken. Deze order annuleren?",
  添加收款方式: "Ontvangstmethode toevoegen",
  是否删除此收款方式: "Deze ontvangstmethode verwijderen?",
  删除: "Verwijderen",
  请选择法币: "Selecteer fiatvaluta",
  机构名称: "Naam instelling",
  请选择机构: "Selecteer instelling",
  "当您出售数字货币时，您选择的收款方式将向买方展示，请确认填写无误。":
    "Uw gekozen ontvangstmethode wordt getoond aan kopers wanneer u crypto verkoopt. Controleer of de gegevens kloppen.",
  请选择银行: "Selecteer bank",
  请输入姓名: "Voer naam in",
  账号: "Rekeningnummer",
  请输入账号: "Voer rekeningnummer in",
  收款码: "Ontvangstcode",
  "银行账号/卡号": "Bankrekening/kaartnummer",
  "请输入银行账号/卡号": "Voer bankrekening/kaartnummer in",
  "开户支行（选填）": "Bankfiliaal (optioneel)",
  请输入开户支行: "Voer bankfiliaal in",
  "加入*官方频道": "Word lid van het officiële *-kanaal",
  关于: "Over",
  条款: "Voorwaarden",
  成功: "Gelukt",
  等待: "Wachten",
  作废: "Ongeldig",
  确认付款: "Bevestig betaling",
  "是否已完成付款？若确认付款后，商家将会在*分内进行确认是否收到付款。":
    "Betaling voltooid? Na bevestiging controleert de verkoper de ontvangst binnen * minuten.",
  最大金额: "Maximum bedrag",
  最小金额: "Minimum bedrag",
  付款: "Betalen",
  法币充值: "Fiat storten",
  法币提现: "Fiat opnemen",
  待支付: "Te betalen",
  已支付: "Betaald",
  商户名: "Verkopersnaam",
  当前没有添加支付方式: "Geen betaalmethode toegevoegd",
  添加后再出售: "Voeg er een toe voordat u verkoopt",
  新人大礼包: "Welkomstpakket",
  注册即可领取: "Claim na registratie",
  立即领取: "Nu claimen",
  不再提示: "Niet meer tonen",
  "该奖励需在APP中领取，请下载APP":
    "Deze beloning kan alleen in de app worden geclaimd. Download de app.",
  去交易: "Ga handelen",
  期权交易: "Optiehandel",
  交易额: "Handelsbedrag",
  可用额度: "Beschikbaar tegoed",
  交易周期: "Handelsperiode",
  看涨: "Bullish (Call)",
  看跌: "Bearish (Put)",
  看空: "Short",
  当前持有: "Huidige positie",
  胜率: "Winpercentage",
  "盈利/亏损数": "Aantal winst/verlies transacties",
  累计实现盈亏: "Gerealiseerd totaalresultaat",
  秒: "seconden",
  分: "minuten",
  小时: "uur",
  周: "week",
  下单时间: "Ordertijd",
  剩余时间: "Resterende tijd",
  买入价: "Aankoopprijs",
  结算价: "Afrekenprijs",
  实现盈利: "Gerealiseerde winst",
  结算时间: "Afrekentijd",
  期权: "Optie",
  新手教程: "Gids voor beginners",
  我的订单: "Mijn orders",
  赔率: "Odds",
  全部订单: "Alle orders",
  持有订单: "Open orders",
  历史订单: "Ordergeschiedenis",
  输入交易额度: "Voer handelsbedrag in",
  选择交易周期: "Selecteer handelsperiode",
  去注册: "Registreer",
  冻结: "Bevriezen",
  期权支出: "Optie-uitgave",
  期权收入: "Optie-inkomsten",
  用户提现: "Gebruikersopname",
  "是否购买？": "Deze optie kopen?",
  购买成功: "Aankoop gelukt",
  请签名: "Gelieve te ondertekenen",
  提交签名: "Ondertekening indienen",
  清空签名: "Ondertekening wissen",
  签名审核中: "Ondertekening in behandeling",
  已提交: "Ingediend",
  扫一扫下载APP: "Scan om de app te downloaden",
  新手领取大礼包: "Nieuwkomer welkomstpakket",
  注册实名即送彩金: "Registreer en verifieer om bonus te ontvangen",
  交易总额: "Totaal handelsvolume",
  资产不足: "Onvoldoende saldo",
  "Win账户的资产不足，可从资金账户划转至此账户":
    "Onvoldoende saldo op WIN-rekening. U kunt activa overboeken van uw hoofdrekening.",
  Win: "WIN",
  比赛: "Wedstrijd",
  未开始: "Niet begonnen",
  赛程: "Schema",
  赛果: "Resultaat",
  已结束: "Geëindigd",
  让球: "Handicap",
  进球数: "Doelpunten",
  大: "Over",
  小: "Under",
  胜负平: "1X2 (Winst/Gelijkspel/Verlies)",
  和局: "Gelijkspel",
  投注: "Inzet",
  下注金额: "Inzetbedrag",
  下注: "Plaats inzet",
  阵容: "Opstelling",
  分析: "Analyse",
  输入下注金额: "Voer inzetbedrag in",
  下注成功: "Inzet geplaatst",
  投注记录: "Inzetgeschiedenis",
  未结算: "Niet verrekend",
  已结算: "Verrekend",
  流水: "Omzet",
  输赢: "Winst/Verlies",
  赛时: "Wedstrijdtijd",
  下注时间: "Inzettijdstip",
  足彩竞猜: "Voetbalweddenschap",
  查看详情: "Bekijk details",
  输: "Verlies",
  赢: "Winst",
  主: "Thuis",
  客: "Uit",
  主胜: "Thuiswinst",
  客胜: "Uitwinst",
  平: "Gelijkspel",
  已延期: "Uitgesteld",
  账号异常: "Account afwijking",
  全场独赢: "Fulltime 1X2",
  全场让球: "Fulltime Handicap",
  全场大小: "Fulltime Over/Under",
  总进球: "Totaal aantal doelpunten",
  拍摄照片要求: "Foto-eisen",
  标准拍摄: "Standaard foto",
  边框缺失: "Rand ontbreekt",
  照片模糊: "Foto onscherp",
  闪光强烈: "Te felle flits",
  上传手持证件照: "Upload foto met document in de hand",
  上传证件照: "Upload documentfoto",
  换一张: "Nieuwe foto",
  出生日期: "Geboortedatum",
  请选择出生日期: "Selecteer geboortedatum",
  "输入下方正确的图形验证后，获取邮箱验证码进行注册":
    "Voer de onderstaande verificatiecode in om een e-mailcode te krijgen voor registratie.",
  "您还剩余*次认证次数，超出次数将无法继续认证":
    "U heeft nog * verificatiepogingen over. Daarna kunt u niet meer verifiëren.",
  上半场: "1e helft",
  下半场: "2e helft",
  独赢: "1X2",
  上半场独赢: "1e helft 1X2",
  下半场独赢: "2e helft 1X2",
  上半场让球: "1e helft Handicap",
  下半场让球: "2e helft Handicap",
  上半场大小球: "1e helft Over/Under",
  下半场大小球: "2e helft Over/Under",
  波胆: "Correcte score",
  上半场波胆: "1e helft Correcte score",
  下半场波胆: "2e helft Correcte score",
  单双: "Even/Odd",
  单: "Odd",
  双: "Even",
  上半场单双: "1e helft Even/Odd",
  下半场单双: "2e helft Even/Odd",
  上半场总进球: "1e helft Totaal doelpunten",
  下半场总进球: "2e helft Totaal doelpunten",
  中场: "Rust",
  "注意：手持证件照请按照此示例图在白纸上书写文字并与证件一起拍摄":
    "Let op: Voor de foto met document in de hand schrijft u de tekst op een wit vel papier en fotografeert u dit samen met uw document, zoals in het voorbeeld.",
  "近期发现大量作弊账户，对一批违规账户进行了惩罚。如果有误判为违规账户，请联系在线客服。":
    "Er zijn recent veel frauduleuze accounts bestraft. Neem contact op met de klantenservice als u denkt dat uw account ten onrechte is bestraft.",
  最小下注金额: "Minimale inzet",
  参与活动最小下注金额: "Minimale inzet voor deelname aan actie",
  记住密码: "Wachtwoord onthouden",
  比分: "Score",
  "您还未登录，请先登录": "U bent niet ingelogd. Log eerst in.",
  立即登录: "Direct inloggen",
  下注限额: "Inzetlimiet",
  可赢金额: "Te winnen bedrag",
  闪兑详情: "Details snelle omwisseling",
  大小球: "Over/Under",
  "由于汇率原因，下注金额和实际下注金额会有误差，请以订单为准。":
    "Door wisselkoersschommelingen kan het uiteindelijke inzetbedrag afwijken. De order is leidend.",
  开赛时间: "Aanvangstijd",
  足球收入: "Voetbal inkomsten",
  足球支出: "Voetbal uitgaven",
  活动详情: "Actiedetails",
  为世界杯喝彩: "Support het WK",
  我的竞猜: "Mijn voorspellingen",
  "竞猜比赛、有机会瓜分*USDT":
    "Voorspel wedstrijden en maak kans op een deel van * USDT",
  "瓜分*USDT": "Verdeel * USDT",
  距离活动结束还有: "Nog tot einde actie:",
  我的门票: "Mijn tickets",
  竞猜结束时间: "Einde voorspellingen",
  猜比分: "Voorspel score",
  "福利派送中，完成任务即可获取门票":
    "Bonussen worden uitgedeeld. Voltooi taken om tickets te verdienen.",
  "完成如下任务，可获对应数量门票的参与竞赛":
    "Voltooi de onderstaande taken om het bijbehorende aantal tickets te verdienen voor deelname aan de wedstrijd.",
  时: "uur",
  活动: "Actie",
  竞猜记录: "Voorspellingsgeschiedenis",
  结果: "Resultaat",
  任务: "Taak",
  去邀请: "Uitnodigen",
  "每场比赛的比分竞猜，参与竞猜可瓜分$*美金的奖励。":
    "Voorspel de score van elke wedstrijd en maak kans op een deel van $*.",
  "参与竞猜需要门票，门票可按照平台的任务进行获得。":
    "Er is een ticket nodig om te voorspellen. Tickets kunnen worden verdiend door platformtaken te voltooien.",
  "竞猜成功后，把竞猜结果的截图发送给客服，客服会把奖金划入您的资金账户，你可以立即提取。":
    "Stuur na een succesvolle voorspelling een screenshot naar de klantenservice. Zij zullen het bonusbedrag naar uw account overboeken, dat u direct kunt opnemen.",
  "禁止任何作弊行为、如果发现作弊行为，奖励无效。":
    "Fraude is verboden. Bij constatering vervalt de beloning.",
  "完成任务后，点击咨询客服获得门票。":
    "Klik na het voltooien van de taken op 'Contact opnemen met klantenservice' om tickets te ontvangen.",
  继续猜: "Blijf voorspellen",
  总单数: "Totaal aantal weddenschappen",
  赛事筛选: "Filter op evenement",
  球队筛选: "Filter op team",
  总金额: "Totaalbedrag",
  总流水: "Totale omzet",
  派奖金额: "Uitgekeerd bonusbedrag",
  下注单数: "Aantal weddenschappen",
  利润: "Winst",
  更多福利: "Meer bonussen",
  我的奖金: "Mijn bonus",
  未认证: "Niet geverifieerd",
  总量: "Totaal",
  或: "of",
  模拟交易: "Demo-handel",
  体验账户不可操作: "Niet beschikbaar op demo-account",
  世界杯比分竞猜: "WK Score Voorspelling",
  "领*USDT起": "Ontvang vanaf * USDT",
  消息: "Berichten",
  滚球: "Live wedden",
  是: "Ja",
  不是: "Nee",
  当前余额: "Huidig saldo",
  KOL招募: "KOL Werving",
  本月净输赢: "Netto winst/verlies deze maand",
  本月佣金: "Commissie deze maand",
  佣金比例: "Commissiepercentage",
  活跃人数: "Actieve gebruikers",
  新增下级: "Nieuwe downlines",
  登录人数: "Ingelogde gebruikers",
  首存人数: "Eerste storting gebruikers",
  数据分析: "Data-analyse",
  人数: "Aantal personen",
  新注册存款金额: "Stortingsbedrag nieuwe registraties",
  老用户存款金额: "Stortingsbedrag bestaande gebruikers",
  首存金额: "Eerste stortingsbedrag",
  快捷入口: "Snelle toegang",
  成员管理: "Ledenbeheer",
  财务报表: "Financiële rapporten",
  分红报表: "Dividend rapport",
  订单记录: "Ordergeschiedenis",
  VIP专享: "VIP exclusief",
  推广工具: "Promotie tools",
  计算规则: "Berekeningsregels",
  账变明细: "Transactiedetails",
  成员: "Leden",
  下级概览: "Overzicht downlines",
  下级成员总计: "Totaal downlines",
  本月新增: "Deze maand nieuwe",
  本月活跃会员: "Actieve leden deze maand",
  今日活跃会员: "Actieve leden vandaag",
  本月有效活跃: "Effectief actief deze maand",
  活跃成员占比: "Percentage actieve leden",
  本月活跃: "Actief deze maand",
  今日活跃: "Actief vandaag",
  下级成员: "Downlines",
  会员账号: "Lid account",
  统计时间: "Statistiektijd",
  筛选: "Filter",
  存款: "Storting",
  取款: "Opname",
  总输赢: "Totaal winst/verlies",
  是否有效用户: "Is actieve gebruiker?",
  最近登录时间: "Laatste login",
  否: "Nee",
  开始时间: "Starttijd",
  结束时间: "Eindtijd",
  提取: "Opnemen",
  总盈亏: "Totaal resultaat",
  净盈亏: "Netto resultaat",
  分红: "Dividend",
  概览: "Overzicht",
  月度详细数据: "Maandelijkse details",
  未发放: "Niet uitgekeerd",
  活跃用户: "Actieve gebruikers",
  有效新增会员: "Effectieve nieuwe leden",
  冲正后净输赢: "Netto winst/verlies na correctie",
  上月结余: "Saldo vorige maand",
  净输赢: "Netto winst/verlies",
  "系统每日新加坡时间1:00更新一次报表":
    "Rapporten worden dagelijks om 01:00 Singapore tijd bijgewerkt.",
  "报表中数据、总输赢、净输赢中正数表示代理方盈利、负数表示代理方亏损":
    "In de rapporten geven positieve getallen winst voor de partner aan, negatieve getallen verlies voor de partner.",
  "佣金数据每天进行更新，仅供参考，并不做实际佣金派发标准":
    "Commissiegegevens worden dagelijks bijgewerkt, zijn indicatief en vormen geen definitieve uitkeringsbasis.",
  选择时间: "Selecteer tijd",
  足球: "Voetbal",
  投注金额: "Inzetbedrag",
  有效订单: "Geldige orders",
  下级账户: "Downline account",
  待成交: "In afwachting",
  下单金额: "Orderbedrag",
  订单内容: "Orderinhoud",
  秒数: "Seconden",
  联赛: "Competitie",
  队伍: "Team",
  比赛时间: "Wedstrijdtijd",
  玩法: "Weddenschapstype",
  等级规则表: "Niveau regels tabel",
  等级: "Niveau",
  活跃会员: "Actieve leden",
  最新活跃: "Laatste activiteit",
  额外佣金: "Extra commissie",
  "每月按照对应等级的增长标准与奖励制度执行，只可享受一个等级奖励。":
    "Elke maand gebaseerd op groeistandaarden. Er kan slechts van één niveau worden geprofiteerd.",
  渠道生成: "Kanaal genereren",
  创建: "Creëren",
  渠道名称: "Kanaalnaam",
  注册人数: "Aantal registraties",
  浏览人数: "Aantal weergaven",
  构建状态: "Bouwstatus",
  禁用: "Uitschakelen",
  启用: "Inschakelen",
  查看: "Bekijken",
  创建渠道: "Kanaal aanmaken",
  创建成功: "Aanmaken gelukt",
  操作成功: "Actie gelukt",
  渠道详情: "Kanaaldetails",
  邀请码: "Uitnodigingscode",
  访问人数: "Aantal bezoekers",
  渠道地址: "Kanaaladres",
  我的福利: "Mijn bonussen",
  充值福利: "Stortingsbonus",
  当前流水: "Huidige omzet",
  如何参与: "Hoe deel te nemen",
  币种充值: "Cryptocurrency storting",
  充值福利中领取福利: "Claim bonus bij stortingsbonus",
  "规则：充值福利自愿领取，有效期为充值后的24小时内，过期无效，领取后将暂时锁定提现功能，当流水达到后即可解锁提现。":
    "Regel: Stortingsbonus is vrijwillig, geldig gedurende 24 uur na storting. Na claimen wordt opname tijdelijk geblokkeerd tot de omzetvereiste is bereikt.",
  失效日期: "Vervaldatum",
  "暂无福利领取，充值后领取": "Geen bonus beschikbaar. Claim na storting.",
  参与: "Deelnemen",
  充值赠送: "Stortingsbonus",
  "领取*%的赠送": "Claim *% bonus",
  去领取: "Claimen",
  VIP奖励: "VIP Beloning",
  "当前可领取*USDT，是否确认领取":
    "* USDT beschikbaar om te claimen. Bevestigen?",
  "领取后将临时锁定提现功能，当您的流水到达*USDT后即可解除锁定":
    "Na claimen wordt opname tijdelijk geblokkeerd tot een omzet van * USDT is bereikt.",
  充值送大礼: "Stortingscadeau",
  "存入越多，送越多！": "Hoe meer u stort, hoe groter het cadeau!",
  无效: "Ongeldig",
  有效: "Geldig",
  总存金额: "Totaal gestort bedrag",
  提示: "Melding",
  "总输赢，净输赢中正数表示平台盈利，负数表示亏损，每天数据只做参考，并不做实际佣金派发标准。":
    "Positieve getallen in totaal en netto winst/verlies betekenen platformwinst. Dagelijkse gegevens zijn indicatief.",
  "净盈亏：总盈亏-用户返水":
    "Netto resultaat: Totaal resultaat - Cashback aan gebruikers",
  盈利方: "Winstgevende partij",
  代理: "Agent",
  客户: "Klant",
  平局: "Gelijkspel",
  平台: "Platform",
  "已提交审核，请耐心等待": "Ter verificatie ingediend. Even geduld a.u.b.",
  充值日期: "Stortingsdatum",
  平台本月总输赢: "Platform totaal winst/verlies deze maand",
  KOL招募合作: "KOL Werving Samenwerking",
  "平台现在开放【KOL招募活动】，只要您有社群媒体号，就可以和平台享受分红一次性推广客户，就可以享受终生收益。":
    "Het platform opent de KOL-werving. Met een social media account kunt u genieten van dividend en levenslange inkomsten door eenmalige klantwerving.",
  级别: "Niveau",
  平台利润返佣: "Platform winstcommissie",
  佣金案例: "Commissie voorbeeld",
  交易项目: "Handelsproducten",
  "期权交易、合约交易、足球游戏": "Optiehandel, Futureshandel, Voetbalspellen",
  报名方式: "Aanmeldingsmethode",
  点击KOL招募报名: "Klik om u aan te melden voor KOL-werving",
  "欢迎加入我们的团队，平台全面扶持您建立属于自己的用户体系，最高可得*的佣金，我们期待您加入。":
    "Welkom bij ons team. Wij ondersteunen u bij het opbouwen van uw eigen gebruikerssysteem. Verdien tot *% commissie. We kijken uit naar uw deelname.",
  输入联系方式: "Voer contactgegevens in",
  最低活跃人数: "Minimaal aantal actieve gebruikers",
  "如：本月活跃人数≥*并且本月平台总输赢≥*USDT，您属于等级*，即可得到*%的佣金。":
    "Bijv.: Als actieve gebruikers deze maand ≥ * en platform totaal winst/verlies ≥ * USDT, valt u onder niveau * en ontvangt u *% commissie.",
  比分竞猜: "Score voorspelling",
  豪礼相赠: "Groots cadeau",
  足球活动: "Voetbalactie",
  圣诞节活动: "Kerstactie",
  "您参加了活动，临时锁定提现功能，还需*USDT流水就可以解除锁定。":
    "U heeft deelgenomen aan een actie. Opname is tijdelijk geblokkeerd. Nog * USDT omzet nodig om te deblokkeren.",
  剩余流水: "Resterende omzet",
  助力足球: "Steun voetbal",
  佣金累计: "Commissie totaal",
  有效投注: "Geldige inzet",
  今日: "Vandaag",
  今日返水: "Cashback vandaag",
  VIP返水: "VIP Cashback",
  返水记录: "Cashback geschiedenis",
  成员信息: "Ledeninformatie",
  基本信息: "Basisinformatie",
  钱包余额: "Portemonnee saldo",
  投注信息: "Inzetinformatie",
  返水: "Cashback",
  总下注: "Totale inzet",
  今日输赢: "Winst/verlies vandaag",
  下注动态: "Inzetactiviteit",
  返水奖励: "Cashback beloning",
  分红金额: "Dividendbedrag",
  返水支出: "Cashback uitgave",
  总返水: "Totale cashback",
  流水总额: "Totale omzet",
  返水总额: "Totaal cashback",
  返水详情: "Cashback details",
  日流水: "Dagelijkse omzet",
  "平台根据你下级每日流水进行额外返水奖励,奖励每日新加坡时间00：00进行派发至赏金账户":
    "Platform geeft extra cashback op basis van de dagelijkse omzet van uw downlines. Uitbetaling dagelijks om 00:00 Singapore tijd naar Bounty-rekening.",
  "申请成功，等待审核": "Aanvraag gelukt, in afwachting van verificatie",
  "我出本金，盈利共分享": "Ik geef kapitaal, winst wordt gedeeld",
  最高分红: "Maximaal dividend",
  投资大师比赛: "Master Investor competitie",
  "我出本金，你盈利": "Ik geef kapitaal, jij wint",
  共分享: "Samen delen",
  最高分红可得: "Maximaal haalbaar dividend",
  "新用户专属福利来袭，免费赠送$*，领取后即可投资平台任何项目，盈利后立即可提取。":
    "Exclusieve welkomstbonus: $* gratis. Na claimen kunt u investeren in elk project. Winst is direct opneembaar.",
  报名领取: "Aanmelden en claimen",
  审核驳回: "Verificatie afgewezen",
  驳回原因: "Reden voor afwijzing",
  活动运行周期: "Actieperiode",
  "申请成功后起至*天内完成超额收益。":
    "Binnen * dagen na goedkeuring overtollig rendement behalen.",
  分红比: "Dividendratio",
  "*日获得盈利后，可获得*%的收益额。":
    "Na het behalen van winst op dag *, ontvangt u *% van het rendementsbedrag.",
  参与条件: "Deelnamevoorwaarden",
  "俄罗斯、土耳其地区的用户，且未参与。":
    "Gebruikers uit Rusland of Turkije die nog niet eerder hebben deelgenomen.",
  计算项目: "Gecalculeerde producten",
  "合约、体育、期权": "Futures, Sport, Opties",
  我的投资: "Mijn investeringen",
  参与天数: "Deelnametijd (dagen)",
  累计下注: "Totale inzet",
  累计盈亏: "Totaal winst/verlies",
  预计可分红: "Verwacht dividend",
  常见问题: "Veelgestelde vragen (FAQ)",
  什么是平台出资: "Wat is platformfinanciering?",
  "平台根据部分国家的用户，免费提供资金让用户去投项目。":
    "Het platform verstrekt gratis fondsen aan gebruikers uit geselecteerde landen om te investeren in projecten.",
  怎么获取平台出资的福利: "Hoe ontvang ik de platformfinancieringsbonus?",
  "您是指定国家的用户即可，点击上方报名按钮，当平台审核完成后将会把*USDT转入当前账户下的赏金账户，您可划转至其他账户下进行投资。":
    "Als u uit een van de aangewezen landen komt, klikt u op de aanmeldknop. Na goedkeuring wordt * USDT overgemaakt naar uw Bounty-rekening, die u kunt overboeken om te investeren.",
  什么是分红: "Wat is dividend?",
  "分红指在规定时间内，收益额到达100%后，可分得超额收益的50%。例如：领取100USDT资金，收益额度是120%。":
    "Dividend: Als binnen de gestelde tijd het rendement 100% bereikt, ontvangt u 50% van het overtollige rendement. Bijv.: Ontvang 100 USDT, behaal 120% rendement, dan is 20% overtollig.",
  "如何取得分红？": "Hoe krijg ik dividend?",
  "活动周期每*天1次，活动结束后进行核算，满足活动要求后分红派发至赏金账户。若你未达到活动要求，系统将自动清除你的收益额和平台的出资。":
    "De actiecyclus is elke * dagen. Na afloop wordt verrekend. Bij voldoen aan de eisen wordt dividend naar de Bounty-rekening gestuurd. Indien niet voldaan, worden uw rendement en de platformfinanciering verwijderd.",
  "参与的账号需进行KYC认证，每个账户仅限一份福利。":
    "Deelnemende accounts moeten KYC-geverifieerd zijn. Slechts één bonus per account.",
  "参与账号的KYC需要指定的国家方可参与，其他地区无权限参与，请核对活动国家与您的国家是否一致。":
    "KYC voor deelname is alleen geldig voor aangewezen landen. Controleer of uw land overeenkomt met het actieland.",
  "参与活动成功后，账户将临时锁定您的提现功能，当完成活动后即可解除您的提现功能。":
    "Na succesvolle deelname wordt opname tijdelijk geblokkeerd tot de actie is voltooid.",
  "请遵守平台活动规则，若发现作弊、利用系统漏洞进行获利，平台将会长期冻结您的账户下所有资金。":
    "Houd u aan de actieregels. Bij fraude of misbruik van systeemfouten worden alle tegoeden op uw account permanent bevroren.",
  平台出资: "Platformfinanciering",
  平台出资收回: "Platformfinanciering teruggenomen",
  投资大师奖励: "Master Investor beloning",
  请下载APP添加收款方式:
    "Download de app om een ontvangstmethode toe te voegen",
  请下载APP进行身份验证:
    "Download de app om identiteitsverificatie uit te voeren",
  请下载APP参与: "Download de app om deel te nemen",
  技术指标: "Technische indicatoren",
  主图: "Hoofdgrafiek",
  副图: "Subgrafiek",
  新注册人数: "Nieuwe registraties",
  老用户存款人数: "Bestaande gebruikers die storten",
  存款人数: "Aantal stortingen",
  取款人数: "Aantal opnames",
  投注人数: "Aantal weddenschappen",
  "除印度尼西亚、印度、孟加拉国，且未参与过的用户。":
    "Exclusief gebruikers uit Indonesië, India, Bangladesh die nog niet eerder hebben deelgenomen.",
  市场动态: "Marktdynamiek",
  外汇合约: "Forex futures",
  盈亏比: "Winst/Verlies ratio",
  委托价: "Orderprijs",
  可用余额: "Beschikbaar saldo",
  持仓额: "Positiewaarde",
  强平价: "Liquidatieprijs",
  修改: "Wijzigen",
  修改价位: "Prijs wijzigen",
  外汇: "Forex",
  外汇账户: "Forex account",
  我的交易: "Mijn transacties",
  未设置: "Niet ingesteld",
  超出最大可设数值: "Overschrijdt maximaal instelbare waarde",
  超出最小可设数值: "Valt onder minimaal instelbare waarde",
  止盈超出最小可设数值: "Take-profit valt onder minimaal instelbare waarde",
  止损超出最大可设数值: "Stop-loss overschrijdt maximaal instelbare waarde",
  止盈超出最大可设数值: "Take-profit overschrijdt maximaal instelbare waarde",
  止损超出最小可设数值: "Stop-loss valt onder minimaal instelbare waarde",
  挖矿: "Mining",
  交易账户: "Handelsaccount",
  买涨: "Kopen (Long)",
  买跌: "Verkopen (Short)",
  请输入正确的银行卡信息: "Voer correcte bankkaartgegevens in",
  联系在线客服: "Neem contact op met klantenservice",
  法币交易请联系在线客服: "Neem voor fiat-handel contact op met klantenservice",
  提交订单: "Order indienen",
  "支付过程如有疑问,请联系在线客服":
    "Neem bij vragen over het betalingsproces contact op met de klantenservice",
  彩金赠送: "Bonusuitkering",
  在线客服: "Live chat",
  最少投资: "Minimale investering",
  "提交时间:": "Indieningstijd:",
  提现拒绝: "Opname geweigerd",
  认证拒绝: "Verificatie geweigerd",
  认证通过: "Verificatie goedgekeurd",
  请输入正确的交易额度: "Voer een geldig handelsbedrag in",
  最大下注金额: "Maximale inzet",
  手机号: "Mobiel nummer",
  邮箱注册: "Registreer met e-mail",
  手机号注册: "Registreer met mobiel nummer",
  查询: "Opvragen",
  手机号登录: "Inloggen met mobiel nummer",
  邮箱登录: "Inloggen met e-mail",
  请输入数量: "Voer hoeveelheid in",
  可用数量: "Beschikbare hoeveelheid",
  钱包登录: "Inloggen met wallet",
  请输入正确的邀请码: "Voer een geldige uitnodigingscode in",
  "请输入邀请码(必填)": "Voer uitnodigingscode in (verplicht)",
  输入正确的金额: "Voer een geldig bedrag in",
  法币充值: "Fiat storten",
  卢比充值: "Indiase Roepie (INR) storten",
  请输入法币: "Voer fiatbedrag in",
  请输入IFSC: "Voer IFSC-code in",
  "银行编码(选填)": "Bankcode (optioneel)",
  请输入银行编码: "Voer bankcode in",
  请输入大于8位数的密码: "Voer een wachtwoord van meer dan 8 tekens in",
  添加成功: "Toevoegen gelukt",
  "60秒": "60 seconden",
  "180秒": "180 seconden",
  "300秒": "300 seconden",
  "2次密码不一致": "Wachtwoorden komen niet overeen",
  输入提币数量: "Voer opnamehoeveelheid in",
  图片格式不正确: "Ongeldig afbeeldingsformaat",
  图片大于20M: "Afbeelding is groter dan 20MB",
  请设置委托价格: "Stel een orderprijs in",
  输入资金密码: "Voer activawachtwoord in",
  验证码错误: "Verificatiecode onjuist",
  充值拒绝: "Storting geweigerd",
  请输入SSN: "Voer SSN in",
  结算完成: "Afrekening voltooid",
  继续下单: "Doorgaan met bestellen",
  限价: "Limit order",
  买入价格: "Aankoopprijs",
  买入量: "Te kopen hoeveelheid",
  卖出价格: "Verkoopprijs",
  卖出量: "Te verkopen hoeveelheid",
  买入: "Kopen",
  卖出: "Verkopen",
  订单创建成功: "Order succesvol aangemaakt",
  币币买入支出: "Uitgave spot aankoop",
  币币买入支出退还: "Terugbetaling uitgave spot aankoop",
  币币买入获得: "Ontvangen spot aankoop",
  币币卖出支出: "Uitgave spot verkoop",
  币币卖出支出退还: "Terugbetaling uitgave spot verkoop",
  币币卖出获得: "Ontvangen spot verkoop",
  币币交易手续费: "Spot transactiekosten",
  请输入限价: "Voer limit prijs in",
  成交: "Uitgevoerd",
  等待成交: "In afwachting van uitvoering",
  交易完成: "Transactie voltooid",
  被取消: "Geannuleerd",
  交易时间: "Transactietijd",
  法币交易: "Fiat-handel",
  法币出售: "Fiat-verkoop",

  两次密码不一致: "Wachtwoorden komen niet overeen",
  再次输入账户密码: "Voer het accountwachtwoord opnieuw in",

  美国: "Verenigde Staten",
  韩国: "Zuid-Korea",
  阿尔巴尼亚: "Albanië",
  津巴布韦: "Zimbabwe",
  赞比亚: "Zambia",
  也门: "Jemen",
  美属维尔京群岛: "Amerikaanse Maagdeneilanden",
  英属处女群岛: "Britse Maagdeneilanden",
  越南: "Vietnam",
  委内瑞拉: "Venezuela",
  瓦努阿图: "Vanuatu",
  乌兹别克斯坦: "Oezbekistan",
  乌拉圭: "Uruguay",
  英国: "Verenigd Koninkrijk",
  阿拉伯联合酋长国: "Verenigde Arabische Emiraten",
  乌克兰: "Oekraïne",
  乌干达: "Oeganda",
  特克斯和凯科斯群岛: "Turks- en Caicoseilanden",
  土库曼斯坦: "Turkmenistan",
  土耳其: "Turkije",
  突尼斯: "Tunesië",
  特立尼达和多巴哥: "Trinidad en Tobago",
  汤加: "Tonga",
  多哥: "Togo",
  东帝汶: "Oost-Timor",
  泰国: "Thailand",
  坦桑尼亚: "Tanzania",
  塔吉克斯坦: "Tadzjikistan",
  中国台湾: "Taiwan",
  叙利亚: "Syrië",
  瑞士: "Zwitserland",
  瑞典: "Zweden",
  斯威士兰: "Swaziland",
  苏里南: "Suriname",
  苏丹: "Soedan",
  斯里兰卡: "Sri Lanka",
  西班牙: "Spanje",
  南非: "Zuid-Afrika",
  索马里: "Somalië",
  所罗门群岛: "Salomonseilanden",
  斯洛文尼亚: "Slovenië",
  斯洛伐克: "Slowakije",
  "圣马丁岛（荷兰部分）": "Sint Maarten (Nederlands deel)",
  新加坡: "Singapore",
  塞拉利昂: "Sierra Leone",
  塞舌尔: "Seychellen",
  塞尔维亚: "Servië",
  塞内加尔: "Senegal",
  沙特阿拉伯: "Saoedi-Arabië",
  圣多美和普林西比: "Sao Tomé en Principe",
  圣马力诺: "San Marino",
  萨摩亚: "Samoa",
  圣克里斯托弗和尼维斯: "Saint Kitts en Nevis",
  圣文森特和格林纳丁斯: "Saint Vincent en de Grenadines",
  圣彼埃尔和密克隆岛: "Saint-Pierre en Miquelon",
  圣露西亚: "Saint Lucia",
  圣基茨和尼维斯: "Saint Kitts en Nevis",
  卢旺达: "Rwanda",
  俄罗斯: "Rusland",
  罗马尼亚: "Roemenië",
  留尼汪: "Réunion",
  刚果共和国: "Republiek Congo",
  卡塔尔: "Qatar",
  波多黎各: "Puerto Rico",
  葡萄牙: "Portugal",
  波兰: "Polen",
  菲律宾: "Filipijnen",
  秘鲁: "Peru",
  巴拉圭: "Paraguay",
  巴布亚新几内亚: "Papoea-Nieuw-Guinea",
  巴拿马: "Panama",
  巴勒斯坦: "Palestina",
  帕劳: "Palau",
  巴基斯坦: "Pakistan",
  阿曼: "Oman",
  挪威: "Noorwegen",
  尼日利亚: "Nigeria",
  尼日尔: "Niger",
  尼加拉瓜: "Nicaragua",
  新西兰: "Nieuw-Zeeland",
  新喀里多尼亚: "Nieuw-Caledonië",
  荷属安德列斯群岛: "Nederlandse Antillen",
  荷兰: "Nederland",
  尼泊尔: "Nepal",
  纳米比亚: "Namibië",
  缅甸: "Myanmar",
  莫桑比克: "Mozambique",
  摩洛哥: "Marokko",
  蒙特塞拉特岛: "Montserrat",
  黑山: "Montenegro",
  蒙古: "Mongolië",
  摩纳哥: "Monaco",
  摩尔多瓦: "Moldavië",
  墨西哥: "Mexico",
  马约特: "Mayotte",
  毛里求斯: "Mauritius",
  毛里塔尼亚: "Mauritanië",
  马里亚纳群岛: "Marianen",
  马提尼克: "Martinique",
  马耳他: "Malta",
  马里: "Mali",
  马尔代夫: "Malediven",
  马来西亚: "Maleisië",
  马拉维: "Malawi",
  马达加斯加: "Madagaskar",
  马其顿: "Noord-Macedonië",
  中国澳门: "Macau",
  卢森堡: "Luxemburg",
  立陶宛: "Litouwen",
  列支敦士登: "Liechtenstein",
  利比亚: "Libië",
  利比里亚: "Liberia",
  莱索托: "Lesotho",
  黎巴嫩: "Libanon",
  拉脱维亚: "Letland",
  老挝: "Laos",
  吉尔吉斯斯坦: "Kirgizië",
  科威特: "Koeweit",
  基里巴斯: "Kiribati",
  肯尼亚: "Kenia",
  哈萨克斯坦: "Kazachstan",
  约旦: "Jordanië",
  日本: "Japan",
  牙买加: "Jamaica",
  象牙海岸: "Ivoorkust",
  意大利: "Italië",
  以色列: "Israël",
  爱尔兰: "Ierland",
  伊拉克: "Irak",
  伊朗: "Iran",
  印度尼西亚: "Indonesië",
  印度: "India",
  冰岛: "IJsland",
  匈牙利: "Hongarije",
  中国香港: "Hongkong",
  洪都拉斯: "Honduras",
  海地: "Haïti",
  圭亚那: "Guyana",
  几内亚比绍共和国: "Guinee-Bissau",
  几内亚: "Guinee",
  危地马拉: "Guatemala",
  关岛: "Guam",
  瓜德罗普岛: "Guadeloupe",
  格林纳达: "Grenada",
  格陵兰岛: "Groenland",
  希腊: "Griekenland",
  直布罗陀: "Gibraltar",
  加纳: "Ghana",
  德国: "Duitsland",
  格鲁吉亚: "Georgië",
  冈比亚: "Gambia",
  加蓬: "Gabon",
  法属波利尼西亚: "Frans-Polynesië",
  法属圭亚那: "Frans-Guyana",
  法国: "Frankrijk",
  芬兰: "Finland",
  斐济: "Fiji",
  法罗群岛: "Faeröer",
  埃塞俄比亚: "Ethiopië",
  爱沙尼亚: "Estland",
  厄立特里亚: "Eritrea",
  赤道几内亚: "Equatoriaal-Guinea",
  萨尔瓦多: "El Salvador",
  埃及: "Egypte",
  厄瓜多尔: "Ecuador",
  多米尼加共和国: "Dominicaanse Republiek",
  多米尼加: "Dominica",
  吉布提: "Djibouti",
  丹麦: "Denemarken",
  捷克: "Tsjechië",
  塞浦路斯: "Cyprus",
  库拉索: "Curaçao",
  古巴: "Cuba",
  克罗地亚: "Kroatië",
  哥斯达黎加: "Costa Rica",
  科特迪瓦: "Ivoorkust",
  库克群岛: "Cookeilanden",
  科摩罗: "Comoren",
  哥伦比亚: "Colombia",
  智利: "Chili",
  乍得: "Tsjaad",
  中非共和国: "Centraal-Afrikaanse Republiek",
  佛得角: "Kaapverdië",
  开曼群岛: "Kaaimaneilanden",
  开普: "Kaap",
  加拿大: "Canada",
  喀麦隆: "Kameroen",
  柬埔寨: "Cambodja",
  布隆迪: "Burundi",
  布基纳法索: "Burkina Faso",
  保加利亚: "Bulgarije",
  文莱: "Brunei",
  巴西: "Brazilië",
  博茨瓦纳: "Botswana",
  波斯尼亚和黑塞哥维那: "Bosnië en Herzegovina",
  玻利维亚: "Bolivia",
  不丹: "Bhutan",
  百慕大群岛: "Bermuda",
  贝宁: "Benin",
  伯利兹: "Belize",
  比利时: "België",
  白俄罗斯: "Wit-Rusland",
  巴巴多斯: "Barbados",
  孟加拉国: "Bangladesh",
  巴林: "Bahrein",
  巴哈马: "Bahama's",
  阿塞拜疆: "Azerbeidzjan",
  奥地利: "Oostenrijk",
  澳大利亚: "Australië",
  阿鲁巴: "Aruba",
  亚美尼亚: "Armenië",
  阿根廷: "Argentinië",
  安提瓜和巴布达: "Antigua en Barbuda",
  安圭拉: "Anguilla",
  安哥拉: "Angola",
  安道尔: "Andorra",
  美属萨摩亚: "Amerikaans-Samoa",
  阿尔及利亚: "Algerije",
  中国: "China",
  余额不足: "Onvoldoende saldo",
  最低购买: "Minimale aankoop",
  最高购买: "Maximale aankoop",
  下单成功: "Order succesvol geplaatst",
  平仓成功: "Positie succesvol gesloten",
  请输入正确的平仓数量: "Voer een geldige sluitingshoeveelheid in",
  加仓成功: "Positie-uitbreiding gelukt",
  请输入正确的加仓金额: "Voer een geldig bedrag voor positie-uitbreiding in",
  收藏成功: "Toegevoegd aan favorieten",
  取消收藏成功: "Verwijderd uit favorieten",
  加密币永续: "Cryptocurrency perpetual",
  外汇永续: "Forex perpetual",
  期权账户: "Optie account",
  快捷卖币: "Snel crypto verkopen",

  托管资金: "Beheerd vermogen",
  托管中: "In beheer",
  预计日收益: "Geschat dagelijks rendement",
  累计收益: "Totaal rendement",
  周期: "Looptijd",
  日收益: "Dagelijks rendement",
  限额: "Limiet",
  立即托管: "Direct vermogen beheren",
  "已鎖定 請聯繫客服": "Geblokkeerd. Neem contact op met de klantenservice.",
  产品列表: "Productenlijst",
  规则: "Regels",
  创建订单: "Order aanmaken",
  产品名称: "Productnaam",
  托管周期: "Beheerperiode",
  等级限制: "Niveau beperking",
  托管金额: "Beheerd bedrag",
  限额: "Limiet",
  余额: "Saldo",
  购买日: "Aankoopdatum",
  起息日: "Rente startdatum",
  派息时间: "Rente uitbetalingstijd",
  每天: "Dagelijks",
  计息结束日: "Rente einddatum",
  每日收益: "Dagelijks rendement",
  预计收益: "Geschat rendement",
  "收益将自动发送至您的余额账户;":
    "Rendement wordt automatisch naar uw saldo gestuurd;",
  "您的资金没有任何风险;": "Uw vermogen loopt geen risico;",
  "365*24小时不断地工作;": "Werkt 24/7, 365 dagen per jaar;",
  托管中: "In beheer",
  结束: "Beëindigd",
  今日收益: "Rendement vandaag",
  剩余周期: "Resterende looptijd",
  进行中: "Actief",
  已发放: "Uitgekeerd",
  信誉分: "Reputatiescore",

  复制成功: "Succesvol gekopieerd",
  VIP权益: "VIP-voordelen",
  旧密码: "Oud wachtwoord",
  请输入旧密码: "Voer het oude wachtwoord in",
  "忘记旧密码请联系客服重置。":
    "Als u uw oude wachtwoord bent vergeten, neem dan contact op met de klantenservice om het te resetten.",
  去升级: "Upgraden",
  描述: "Beschrijving",
  实际存款金额: "Werkelijk stortingsbedrag",
  升级礼金: "Upgradebonus",
  隔夜利息: "Rente over nacht (swap)",
  自动结算: "Automatische vereffening",
  等级规则: "Niveau regels",
  "WEB3.0币持有数据收益": "WEB3.0-muntbezit data rendement",
  总生产: "Totale productie",
  有效节点: "Actieve knooppunten",
  参与人: "Deelnemers",
  用户收益: "Gebruikersrendement",
  "流动性WEB3.0输出": "Liquiditeit WEB3.0-output",
  总资产: "Totaal vermogen",

  ETHAI持有数据收益: "ETHAI bezitsgegevens rendement",
  AI量化流动性: "AI kwantitatieve liquiditeit",
  现货买入手续费: "Spot aankoopkosten",
  现货支出: "Spot uitgave",
  现货资金费率: "Spot financieringsrente",
  现货卖出手续费: "Spot verkoopkosten",
  现货收入: "Spot inkomsten",
  外汇合约支出: "Valutacontract uitgave",
  外汇合约买入手续费: "Valutacontract aankoopkosten",
  外汇合约资金费率: "Valutacontract financieringsrente",
  外汇合约卖出手续费: "Valutacontract verkoopkosten",
  外汇合约收入: "Valutacontract inkomsten",
  理财购买: "Vermogensbeheer aankoop",
  VIP理财日收益: "VIP vermogensbeheer dagelijks rendement",
  VIP理财隔夜利息: "VIP vermogensbeheer overnight rente",
  VIP本金返还: "VIP terugbetaling hoofdsom",
  VIP彩金发放: "VIP bonus uitkering",
  VIP彩金抵扣: "VIP bonus aftrek",
  隔夜利息: "Overnight rente",
  设置资产密码: "Activawachtwoord instellen",

  锁仓挖矿: "Vergrendeld minen",
  一站式理财服务: "Alles-in-één financiële dienst",
  产品: "Producten",
  客服中心: "Klantenservicecentrum",
  贷款: "Leningen",
  挖矿赚不停: "Blijf verdienen met mining",
  "锁仓挖矿是通过将USDT (USD:1USDT=1USD) 托管给平台超算力矿机，在平台矿池中进行挖矿收益。":
    "Vergrendeld minen houdt in dat USDT (USD:1USDT=1USD) wordt toevertrouwd aan de krachtige miningmachines van het platform om opbrengsten te genereren in de miningpool van het platform.",
  产品优势: "Productvoordelen",
  随存随取: "Storten en opnemen op elk moment",
  锁仓周期: "Vergrendelingsperiode",
  每日下发: "Dagelijkse uitbetaling",
  随机空投: "Willekeurige airdrop",
  "100%资金安全保障": "100% fondsbeveiliging",
  "100%节假日收益不间断": "100% continue opbrengsten, ook op feestdagen",
  成功锁仓后当天产出:
    "Opbrengst vanaf dezelfde dag na succesvolle vergrendeling",
  关于违约金: "Over boetes",
  "若您希望转出未到期的本金,则会产生违约金,违约金=违约结算比例*剩余天数*锁仓金额.":
    "Als u uw kapitaal vóór de looptijd wilt opnemen, wordt een boete in rekening gebracht. Boete = boetepercentage × resterende dagen × vergrendeld bedrag.",
  "举例:此锁仓挖矿的违约结算比例为5%,剩余3天到期,锁仓金额为10000U《USDT/USD》,则违约金=5%*3*10000=1500U,实际退回本金为15000U-1500U":
    "Voorbeeld: het boetepercentage is 5%, er zijn 3 dagen resterend en het vergrendelde bedrag is 10000U (USDT/USD). Boete = 5%×3×10000=1500U, het werkelijk terugbetaalde bedrag is 15000U-1500U.",
  收益计算: "Winstberekening",
  "平台有多种锁仓挖矿理财产品供使用者选择,收益计算如下,举例:":
    "Het platform biedt verschillende financiële producten voor vergrendeld minen. De winstberekening is als volgt, bijvoorbeeld:",
  "会员在平台锁仓10000U(USDT,USD),如选择了周期为7天,日产出为锁仓金额的0.7%~1.8%的理财产品,则每天产出如下":
    "Als een gebruiker 10000U (USDT, USD) vergrendelt en een product van 7 dagen kiest met een dagelijks rendement van 0,7%~1,8%, is de dagelijkse opbrengst als volgt:",
  "最低:10000Ux0.7%=70U;": "Minimum: 10000U×0,7%=70U;",
  "最高:10000Ux1.8%=180U;": "Maximum: 10000U×1,8%=180U;",
  "即7天后可获得490U~1260U的收益,收益每日下发,锁仓本金到期后,自动转入您的资金账户.":
    "Na 7 dagen kan een opbrengst van 490U~1260U worden verkregen. De opbrengsten worden dagelijks uitgekeerd en het kapitaal wordt na afloop automatisch naar uw account overgemaakt.",
  正在托管的资金: "Beheerde fondsen",
  签到: "Dagelijkse check-in",
  锁仓订单: "Vergrendelde orders",
  预计今日收益: "Geschatte opbrengst vandaag",
  累计收益: "Totale opbrengst",
  托管中的订单: "Orders in beheer",
  单笔最少: "Minimum per order",
  单笔最多: "Maximum per order",
  日收益率: "Dagelijks rendement",
  说明: "Uitleg",
  "1.数据统计时间以GMT+8时间为准<br>2.每日收益值以GMT+8当天时间00:00-23:59点(本地时间00:00-23:59)的所有已结算订单为基准计算得出<br>3.当天的收益会统一在次日GMT+8时间00:00-00:10内派发.":
    "1. Statistieken zijn gebaseerd op GMT+8 tijd<br>2. Dagelijkse opbrengst wordt berekend op basis van alle afgeronde orders tussen 00:00-23:59 GMT+8 (lokale tijd 00:00-23:59)<br>3. De opbrengst wordt de volgende dag tussen 00:00-00:10 GMT+8 uitgekeerd.",
  知道了: "Begrepen",
  锁仓: "Vergrendelen",
  派息时间: "Uitbetalingstijd",
  每日: "Dagelijks",
  托管资金: "Beheerde fondsen",
  到期返回: "Terugbetaling bij afloop",
  提前赎回: "Vervroegde opname",
  预计收益: "Verwachte opbrengst",
  认购: "Inschrijven",
  热门: "Populair",
  数字货币: "Cryptovaluta",
  贵金属: "Edelmetalen",
  大宗商品: "Grondstoffen",
  持仓明细: "Positiedetails",
  历史明细: "Historie",
  当前价: "Huidige prijs",
  "↑买涨": "↑ Koop stijging",
  "↓买跌": "↓ Koop daling",
  显示全部: "Alles tonen",
  买入金额: "Aankoopbedrag",
  方向: "Richting",
  收益: "Winst",
  预期收益: "Verwachte winst",
  估用保证金: "Geschatte marge",
  确认下单: "Order bevestigen",
  锁定: "Vergrendeld",
  账户总资产: "Totale rekeningactiva",
  明细: "Details",
  今日收益: "Vandaag winst",
  仓位保证金: "Positiemarge",
  持有仓位: "Open posities",
  "锁定金额=所有锁仓挖矿中未完成订单的金额总和":
    "Vergrendeld bedrag = som van alle onvoltooide vergrendelde mining-orders",
  "1.数据统计时间以GMT+8时间为准<br>2.每日收益值以GMT+8当天时间00:00-23:59点(本地时间00:00-23:59)的所有已结算订单为基准计算得出":
    "1. Statistieken zijn gebaseerd op GMT+8 tijd<br>2. Dagelijkse opbrengst wordt berekend op basis van alle afgeronde orders tussen 00:00-23:59 GMT+8",
  充值方式: "Stortingsmethode",
  银行汇款: "Bankoverschrijving",
  "银行汇款请联系客服进行操作!":
    "Neem contact op met de klantenservice voor bankoverschrijving!",
  提款方式: "Opnamemethode",
  "银行提款请联系客服进行操作!":
    "Neem contact op met de klantenservice voor bankopname!",
  资金明细: "Fondsenoverzicht",
  提现记录: "Opnamegeschiedenis",
  拒绝: "Geweigerd",
  通过: "Goedgekeurd",
  拒绝原因: "Reden van afwijzing",

  消息公告: "Meldingen",
  订单: "Bestellingen",
  个人中心: "Persoonlijk centrum",
  "未到期赎回需支付一定的违约金!":
    "Bij vervroegde aflossing moet een boete worden betaald.",

  请输入区号: "Voer de netcode in",
  "请选择国家/地区": "Selecteer een land/regio",

  今日开盘: "Opening vandaag",
  昨日收盘: "Slot van gisteren",

  实名认证即送: "Ontvang direct na identiteitsverificatie",
  立即认证: "Nu verifiëren",
  新用户礼包: "Cadeaupakket voor nieuwe gebruikers",
  完成新人任务领取:
    "Voltooi de taken voor nieuwe gebruikers om het te ontvangen",
  认证: "Verifiëren",
  时间周期: "Tijdsperiode",
  支付金额: "Betalingsbedrag",
  已平仓: "Gesloten",
  "MGBX 新用户欢迎礼包：每位用户最多可获得":
    "MGBX welkomstpakket voor nieuwe gebruikers: elke gebruiker kan maximaal ontvangen",
  我已经阅读并同意: "Ik heb gelezen en ga akkoord met",
  隐私政策: "Privacybeleid",

  放弃奖励离开: "Beloning opgeven en verlaten",
  继续注册: "Doorgaan met registreren",
  分钟: "Minuten",

  "请先勾选隐私政策!": "Bekijk eerst het privacybeleid!",

  添加其他到自选: "Anderen aan de volglijst toevoegen",

  充值最高可得: "Waardeer op en ontvang tot $30.000.",

  请输入格式正确的手机号: "Voer een geldig mobiel telefoonnummer in.",

  收起: "Collapse",
  上传截图: "Upload screenshot",
  "*充值成功后必须上传充值截图，否则将视为无效存款。": "*After a successful recharge, you must upload the recharge screenshot; otherwise the deposit will be invalid.",
};
// 荷兰



// WEBPACK FOOTER //
// ./src/lang/nl.js